import styled from 'styled-components';

export const DetailCardInnerSection = styled.div(
  props => `
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: ${props.theme.colors.blue.bgBlue};
`,
);

export const WrapperSection = styled.section(
  props => `
  background-color: ${props.theme.colors.blue.bgBlue};
  width: 100%;
  flex-direction: column;
  margin: 0 0 ${props.theme.spacing.large.l25} 0

`,
);

export const WrapperDiv = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  padding-top: ${props.theme.spacing.large.l15};
  margin: 0 auto;
`,
);

// new

export const DetailMainWrapper = styled.section(
  props => `
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.bgWhite};
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
  `
);

export const DetailMainInnerWrapper = styled.section`
    width: 100%;
    max-width: 120rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`;


export const DetailsNavWrapper = styled.div(
  props => `
      width:100%;
      display: flex;
      border-bottom: 0.7px solid ${props.theme.colors.grey.lightba};
      margin-top: ${props.theme.spacing.large.l30};
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.nospacing};
  `
);

export const DetailNavInnerWrap = styled.div(
  props => `
      max-width: 120rem;
      width: 100%;
      margin:0 auto;
      display: flex;
  `
);

export const NavList = styled.ul(
  props => `
      width: 100%;
      display: flex;
      align-items: center;
      list-style-type: none;

      li{
          width:20%;
          display: flex;
          text-transform: ${props.theme.font.textTransform.upper};
          color: ${props.theme.colors.grey.base};
          font-size: ${props.theme.font.large.font14};
          cursor: pointer;
          font-weight: ${props.theme.font.fontWeight.black};

          &:hover{
              color: ${props.theme.colors.blue.base};
          }

          &.active{
              color: ${props.theme.colors.blue.base};
          }
      }
  `
);

